import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"hide-details":"auto","label":_vm.$t('Text'),"outlined":""},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }